import { Component } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const capabilityCalloutFields = [
  imageField('backgroundImage'),
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Leave the infrastructure to us',
    helperText: 'Card heading. Supports line breaks with <br /> tags.',
  },
  {
    name: 'supportingText',
    type: 'longText',
    defaultValue: 'Prismatic ensures integrations are reliable, scalable, and secure by default.',
    helperText: 'Supporting copy shown below the heading.',
  },
  {
    name: 'chips',
    type: 'list',
    helperText: 'Capability pills shown between the copy and the button.',
    defaultValue: [
      { label: 'Authentication' },
      { label: 'Deployment' },
      { label: 'Monitoring' },
      { label: 'Logging' },
      { label: 'Scaling' },
    ],
    subFields: [{ name: 'label', type: 'string', required: true, helperText: 'Pill text (shown uppercase).' }],
  },
  {
    name: 'button',
    type: 'object',
    helperText: 'Call-to-action button below the pills. Leave the text empty to hide the button.',
    defaultValue: {
      label: 'Explore the core',
      href: '#',
    },
    subFields: [
      { name: 'label', type: 'string', defaultValue: 'Explore the core', helperText: 'Button text.' },
      {
        name: 'href',
        friendlyName: 'URL',
        type: 'string',
        defaultValue: '#',
        helperText: 'Destination link. Use a relative path (e.g. /platform) or an anchor (e.g. #core).',
      },
    ],
  },
  ...sectionFields,
] as const;

const capabilityCalloutConfig = {
  name: 'CapabilityCallout',
  inputs: capabilityCalloutFields,
} as Component;

export type CapabilityCalloutConfigProps = GenerateBuilder<typeof capabilityCalloutFields>;

export default capabilityCalloutConfig;
